import { EntityType } from '../../../../../../shared/models/entity-type.models'
import { Node } from 'reactflow'
import { BaseNodeData } from '../../base/types'
import { NodeTypes } from '../../../../../../shared/models/rule-node'

export interface ActionEntityOperationFindConfiguration {
  entityType: EntityType
  prefixNamePattern: string
  entityNamePattern: string
  nameKey: string
  idKey: string
}

interface Props {
  onSubmit: (
    data: Node<
      BaseNodeData<ActionEntityOperationFindConfiguration>,
      NodeTypes.ACTION_ENTITY_OPERATION_FIND
    >
  ) => void
  defaultValues: Node<
    BaseNodeData<ActionEntityOperationFindConfiguration>,
    NodeTypes.ACTION_ENTITY_OPERATION_FIND
  >
}

const ActionEntityOperationFindForm = ({ onSubmit, defaultValues }: Props) => {
  return (
    <div>
      <h1>ActionEntityOperationCreate</h1>
    </div>
  )
}

export default ActionEntityOperationFindForm
